{
  "menu": {
    "about": "Sobre Nós",
    "facilities": "Instalações",
    "villas": "Vilas e Tarifas",
    "allRooms": "Todos os Quartos",
    "experiences": "Coisas para Fazer",
    "gallery": "Galeria",
    "news": "Notícias",
    "contact": "Contato",
    "dining": "Jantar",
    "spa": "Spa"
  },
  "cta": {
    "book": "Reserve Agora",
    "contact": "Contate-Nos",
    "back_to_home": "Voltar à Página Inicial",
    "read_more": "Leia Mais"
  },
  "home": {
    "culture": {
      "subtitle": "Autêntica Herança Balinesa",
      "title": "Experiências Culturais",
      "desc": "Mergulhe na rica herança espiritual e cultural de Bali. De rituais sagrados de purificação da água à exploração de antigas tradições, guiamos você em uma jornada para descobrir a verdadeira alma da ilha.",
      "journeySub": "Jornada Espiritual",
      "journeyTitle": "Purificação em Sidemen",
      "journeyDesc": "Experimente um ritual tradicional balinês de purificação da água (Melukat) nas fontes sagradas de Sidemen, projetado para limpar seu corpo, mente e espírito.",
      "btnReserve": "Reserva"
    },
    "activities": {
      "subtitle": "Momentos Curados",
      "title": "Coisas para Fazer",
      "desc": "Oferecemos as melhores atividades cuidadosamente selecionadas para criar memórias inesquecíveis durante a sua estadia. Mergulhe na magia de Bali, de aventuras emocionantes a profundas explorações culturais e bem-estar espiritual.",
      "btnView": "Ver Atividades",
      "btnReserve": "Reserva"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "O Que Nos Torna Diferentes",
      "desc": "Descubra a verdadeira essência de uma joia escondida. Longe das multidões, oferecemos um santuário isolado onde cada detalhe é projetado para ajudá-lo a se desconectar, recarregar as energias e sair com belas memórias que duram a vida toda.",
      "card1": {
        "sub": "Um santuário privado longe do mundo",
        "title": "A Joia Escondida de Sidemen",
        "desc": "Escondida longe das ruas movimentadas, nossa vila oferece a máxima exclusividade e privacidade. Aqui, você não é apenas um hóspede, mas um viajante privilegiado experimentando a serenidade intocada da autêntica Bali."
      },
      "card2": {
        "sub": "Desperte seus sentidos e recarregue sua alma",
        "title": "Energia Renovada",
        "desc": "Respire o ar fresco dos nossos exuberantes jardins tropicais e vastos arrozais. Cada momento passado em nosso ambiente tranquilo é projetado para rejuvenescer sua mente, corpo e espírito."
      },
      "card3": {
        "sub": "Momentos que você guardará para sempre",
        "title": "Belas Memórias",
        "desc": "De sorrisos sinceros a experiências locais autênticas, elaboramos cada detalhe de sua estadia com cuidado genuíno. Volte para casa não apenas descansado, mas com histórias lindas e inesquecíveis para contar."
      }
    },
    "booking": {
      "title": "Pronto para Experimentar Patal Kikian?",
      "desc": "Verifique a disponibilidade e garanta seu santuário privado hoje."
    },
    "contact": {
      "subtitle": "Contato",
      "title": "Como nos alcançar",
      "desc": "Se você tem uma dúvida sobre nossos quartos, precisa de assistência com sua reserva ou tem um pedido especial para sua próxima estadia, nossa equipe de concierge dedicada está aqui para ajudar.",
      "btnEmail": "Enviar um Email",
      "btnWa": "WhatsApp"
    },
    "hero": {
      "subtitle": "Bem-vindo às Villas Patal Kikian",
      "title": "Desperte para o Panorama Mais Deslumbrante de Bali",
      "description": "Abrace a presença majestosa do Monte Agung enquanto ele zela por terraços de arroz esmeralda e vales exuberantes. Aqui no abraço pacífico de Sidemen, o ar puro da montanha e a serenidade intocada se entrelaçam para criar um santuário inesquecível para a sua alma."
    },
    "intro": {
      "quote": "\"Por décadas, a beleza cativante de Sidemen inspirou o mundo.\"",
      "p1": "Em 1938, o lendário artista Walter Spies imortalizou o encanto encantador desta região através de sua obra-prima, <span className=\"italic text-white\">\"Morning in Iseh.\"</span> A pintura capturou lindamente a majestade imponente do Monte Agung, os exuberantes terraços de arroz esmeralda, a suave névoa da manhã e o ritmo pacífico da vida rural balinesa. Até hoje, continua sendo um símbolo icônico do esplendor natural de Bali.",
      "p2": "Hoje, este mesmo panorama deslumbrante se desdobra diante de seus olhos nas Villas Patal Kikian.",
      "p3": "Toda manhã traz um nascer do sol espetacular que banha o Monte Agung em uma luz dourada, iluminando vales verdes amplos e trazendo uma brisa fresca da montanha. Aqui, a tranquilidade reina, fazendo o tempo parecer ter desacelerado.",
      "p4": "No Patal Kikian, você não está apenas hospedado em uma villa de luxo; você está mergulhando na mesma paisagem que cativou artistas, fotógrafos e amantes da natureza de todos os cantos do mundo.",
      "p5": "Oferecemos uma harmonia impecável de luxo refinado, profunda herança cultural e a autêntica beleza natural de Sidemen.",
      "footerQuote": "Chegue para umas férias. Parta com memórias que você sempre ansiará.",
      "footerBrand": "Villas Patal Kikian",
      "footerTagline": "Onde Cada Nascer do Sol se Torna uma Obra-Prima"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Restaurante Patal Kikian",
      "desc": "Situado ao lado de nossa piscina de borda infinita e bar elegante, nosso restaurante oferece uma experiência gastronômica notável emoldurada por vistas deslumbrantes dos vales verdes e vastos arrozais. Saboreie criações culinárias requintadas enquanto a brisa suave e os arredores naturais de tirar o fôlego despertam seus sentidos.",
      "callToAction": "Explore nossas ofertas culinárias requintadas. Descubra nossas especialidades locais e internacionais consultando nosso menu, ou reserve sua mesa para uma experiência gastronômica inesquecível.",
      "btnMenu": "Ver Menu",
      "btnReserve": "Reserva",
      "btnTransport": "Reserva Transporte Especial",
      "btnTransportSub": "(Área de Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Localização"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Spa Patal Kikian",
      "desc": "Rejuvenesça sua mente, corpo e alma no Spa Patal Kikian. Experimente autênticos rituais de cura balineses e massagens relaxantes realizadas por nossos terapeutas qualificados, tudo isso enquanto aprecia a beleza natural deslumbrante de Sidemen.",
      "callToAction": "Descubra nossa gama completa de tratamentos holísticos. Consulte nosso menu do spa para explorar nossas terapias relaxantes, ou reserve sua sessão rejuvenescedora hoje.",
      "btnMenu": "Ver Menu",
      "btnReserve": "Reserva",
      "btnTransport": "Reserva Transporte Especial",
      "btnTransportSub": "(Área de Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Localização"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Villas Patal Kikian",
      "desc": "Cada villa é cuidadosamente projetada como seu santuário privado, oferecendo vistas ininterruptas e deslumbrantes do Monte Agung, vastos campos de arroz e vales verdejantes, misturando perfeitamente o luxo com a serenidade da natureza."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Nossa História",
      "title": "Desperte para o panorama mais deslumbrante de Bali",
      "desc": "Abrace a presença majestosa do Monte Agung enquanto ele vigia os terraços de arroz esmeralda e os vales verdejantes. Aqui, no abraço pacífico de Sidemen, o ar fresco da montanha e a serenidade intacta se entrelaçam para criar um santuário inesquecível.",
      "btnScroll": "Ler História"
    },
    "story": {
      "p1": "Aninhado nos arredores de Sidemen, Karangasem, o Patal Kikian Villas é mais do que apenas um destino; é um convite para experimentar a verdadeira essência de Bali. Com vistas panorâmicas do topo da colina, cada manhã aqui começa com uma sinfonia da natureza: um nascer do sol dourado iluminando o pico imponente do Monte Agung, emoldurado por uma vegetação infinita e paisagens imaculadas.",
      "p2": "Acreditamos que o verdadeiro luxo reside na harmonia com a natureza. Ao entrar em nosso santuário, você é envolvido pelo ar fresco e puro da montanha e por um profundo sentimento de tranquilidade. É um lugar projetado para desconectá-lo do ruído do mundo e reconectá-lo com o que realmente importa.",
      "subtitle": "Uma Harmonia de Natureza e Cultura",
      "p3": "Nossas vilas refletem uma mistura perfeita da arquitetura balinesa tradicional e conforto moderno, cuidadosamente trabalhadas para homenagear a rica cultura de Sidemen. Temos orgulho de nossa hospitalidade calorosa e autêntica. Aqui, cada sorriso é genuíno e cada serviço é prestado com o mais profundo respeito aos nossos hóspedes e ao nosso patrimônio local.",
      "quote": "\"Patal Kikian Villas é o seu paraíso escondido — um lugar onde paisagens majestosas, cultura rica e hospitalidade sincera tecem uma inesquecível tapeçaria de memórias.\"",
      "footer": "Estamos ansiosos para recebê-lo em nosso santuário."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Comodidades do Resort",
      "title": "Nossas Instalações",
      "desc": "Descubra nossas comodidades premium projetadas para proporcionar conforto e relaxamento durante toda a sua estadia em Sidemen.",
      "btnScroll": "Ver Instalações"
    },
    "fallback": {
      "poolSub": "Oásis de Serenidade",
      "poolTitle": "Piscinas",
      "poolDesc1": "Mergulhe em nossas cristalinas piscinas de borda infinita com vista para os vibrantes jardins tropicais e para o vale exuberante. Esteja você desfrutando de um mergulho matinal, um café da manhã flutuante ou simplesmente relaxando sob o sol com um coquetel refrescante, nossas piscinas oferecem o espaço ideal para relaxar.",
      "poolDesc2": "Piscinas de imersão privadas também estão disponíveis em vilas selecionadas para aqueles que buscam um retiro íntimo.",
      "restSub": "Excelência Culinária",
      "restTitle": "Restaurante",
      "restDesc1": "Delicie-se com uma jornada gastronômica em nosso restaurante exclusivo ao ar livre. Temos o orgulho de servir autêntica cozinha balinesa ao lado de favoritos internacionais, tudo feito com os ingredientes orgânicos mais frescos de origem local.",
      "restDesc2": "Aproveite seu café da manhã de cortesia, jantares românticos à luz de velas ou chás da tarde casuais enquanto aprecia as vistas deslumbrantes da natureza ao redor.",
      "restBtn": "Ver Mais",
      "spaSub": "Bem-Estar e Cura",
      "spaTitle": "Spa de Luxo",
      "spaDesc1": "Rejuvenesça sua mente, corpo e alma em nosso tranquilo santuário de spa. Enraizados em antigas tradições de cura balinesas, nossos terapeutas profissionais oferecem uma variedade de tratamentos, desde massagens tradicionais até esfoliações corporais e tratamentos faciais revitalizantes.",
      "spaDesc2": "Como nosso convidado, você também receberá uma massagem nos pés gratuita de 15 minutos na chegada, para lavar instantaneamente a fadiga da viagem.",
      "spaBtn": "Ver Mais"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Nossos Quartos",
      "title": "Santuários de Serenidade no Patal Kikian Villas",
      "desc": "Experimente a tranquilidade suprema em nossas vilas cuidadosamente projetadas, combinando o conforto moderno com a autenticidade balinesa.",
      "btnScroll": "Explorar Quartos"
    },
    "detail": {
      "loading": "Carregando detalhes do quarto...",
      "signature": "Quarto Signature",
      "gallerySub": "Galeria",
      "galleryTitle": "Galeria de Fotos do Quarto",
      "noImages": "Não há imagens disponíveis para este tipo de quarto.",
      "aboutRoom": "Sobre o Quarto",
      "roomSize": "Tamanho do quarto",
      "bedSize": "Tamanho da cama",
      "view": "Vista",
      "amenities": "Comodidades",
      "inclusions": "Inclusões",
      "pleaseNote": "Observe",
      "roomRules": "Regras e Informações",
      "roomPolicy": "Política do Quarto",
      "childrenPolicies": "Políticas para crianças",
      "childrenPolicyDesc": "Crianças de qualquer idade são permitidas. Crianças até 5 anos (inclusive) podem ficar gratuitamente. Crianças de 6 a 12 anos podem ficar por IDR 151.250,00 por criança, por noite, com cama extra.",
      "babyCot": "Berço",
      "babyCotDesc": "Crianças até 2 anos (inclusive) ficam hospedadas gratuitamente quando utilizam um berço disponível.",
      "extraBed": "Cama extra",
      "extraBedDesc": "Pessoas de qualquer idade pagam IDR 302.500,00 por pessoa, por noite, ao usar uma cama extra disponível.",
      "noSmoking": "Não é permitido fumar.",
      "noPets": "Animais de estimação não são permitidos.",
      "reserve": "Reservar",
      "directBooking": "Reserva Direta Conosco",
      "bookOnBooking": "Reservar no Booking.com",
      "contactConcierge": "Entre em contato com nosso concierge para dúvidas sobre reservas e solicitações personalizadas.",
      "otherChoices": "Outras Opções",
      "otherRooms": "Outros Quartos que Você Pode Gostar",
      "bookYourStay": "Reserve Sua Estadia"
    }
  },
  "luxuryCard": {
    "discover": "Descobrir"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Bungalow Deluxe (Vista Montanha)",
      "description": "Este bangalô possui uma piscina de borda infinita. Com uma entrada privativa, este bangalô com ar-condicionado é composto por 1 sala de estar, 1 quarto separado e 1 banheiro com chuveiro e secador de cabelo. O bangalô é mobiliado com uma mesa de trabalho e área de estar e dispõe de frigobar, comodidades para fazer chá e café e vista para o jardim. A unidade oferece 1 cama.",
      "view": "Vista para o Jardim, Piscina, Montanha, Ponto de Referência e Rio",
      "roomRules": "Fumantes: Proibido fumar. Horas de silêncio após as 22h. Check-in às 14h, Check-out às 12h."
    },
    "suite-room-mountain-view": {
      "title": "Quarto Suite (Vista Montanha)",
      "description": "Os hóspedes terão uma experiência especial, pois esta suíte oferece uma piscina com vista. Com uma entrada privativa, esta suíte espaçosa também é composta por 1 quarto, uma área de estar e 1 banheiro com chuveiro e secador de cabelo. A unidade possui ar-condicionado, vista para o jardim, terraço e vinho/champanhe é fornecido aos hóspedes. A unidade oferece 1 cama.",
      "view": "Vista para a Montanha, Rio, Ponto de Referência, Piscina e Jardim",
      "roomRules": "Fumantes: Proibido fumar. Horas de silêncio após as 22h. Check-in às 14h, Check-out às 12h."
    },
    "private-pool-villa-mountain-view": {
      "title": "Vila com Piscina Privativa (Vista Montanha)",
      "description": "Esta vila possui uma piscina com vista. Com uma entrada privativa, esta vila com ar-condicionado é composta por 1 sala de estar, 1 quarto separado e 1 banheiro com banheira e chuveiro. A vila espaçosa dispõe de frigobar, comodidades para fazer chá e café, área de estar e terraço com vista para o jardim. A unidade oferece 1 cama.",
      "view": "Vista para o Jardim, Piscina, Montanha e Rio",
      "roomRules": "Fumantes: Proibido fumar. Horas de silêncio após as 22h. Check-in às 14h, Check-out às 12h."
    },
    "features": {
      "Infinity Pool": "Piscina de Borda Infinita",
      "Mountain View": "Vista para a Montanha",
      "Private Balcony": "Varanda Privativa",
      "Private Pool": "Piscina Privativa",
      "Mount Agung View": "Vista para o Monte Agung",
      "Living Room": "Sala de Estar",
      "Nature View": "Vista para a Natureza",
      "Bedroom": "Quarto"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Coisas Para Fazer",
      "title": "Crie Suas Melhores Memórias em Bali",
      "desc": "Desde aventuras na natureza de tirar o fôlego até experiências culturais imersivas, apresentamos uma seleção de atividades com curadoria para tornar cada momento das suas férias ainda mais especial.",
      "btnScroll": "Ver Atividades"
    },
    "sidebar": {
      "categories": "Categorias",
      "moreActivities": "Mais Atividades"
    },
    "categories": {
      "Adventure & Nature": "Aventura e Natureza",
      "Culture & Art": "Cultura e Arte",
      "Wellness & Spiritual": "Bem-estar e Espiritualidade"
    },
    "items": {
      "ATV Adventure": {
        "title": "Aventura de Quadriciclo",
        "description": "Experimente a emoção de andar de quadriciclo pelas belas paisagens de Bali."
      },
      "Cycling Tour": {
        "title": "Passeio de Bicicleta",
        "description": "Passeie de bicicleta por exuberantes arrozais e vilarejos tradicionais em uma visita guiada."
      },
      "Rice Terrace Walking Tour": {
        "title": "Passeio a Pé pelos Terraços de Arroz",
        "description": "Dê um passeio tranquilo por alguns dos terraços de arroz mais emblemáticos do mundo."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Nascer do Sol de Jeep no Monte Batur",
        "description": "Testemunhe um nascer do sol de tirar o fôlego do Monte Batur sem a caminhada de manhã cedo."
      },
      "Scooter Tour": {
        "title": "Passeio de Scooter",
        "description": "Explore as joias escondidas de Sidemen em um emocionante passeio guiado de scooter."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Experimente a adrenalina do rafting em corredeiras no rio Ayung."
      },
      "Batur Trekking": {
        "title": "Trekking no Monte Batur",
        "description": "Caminhe até o vulcão ativo do Monte Batur e assista ao nascer do sol do cume."
      },
      "Waterfall Tour": {
        "title": "Passeio pelas Cachoeiras",
        "description": "Visite algumas das cachoeiras mais impressionantes e escondidas da região de Sidemen."
      },
      "Swing": {
        "title": "Balanço",
        "description": "Experimente a adrenalina de balançar alto acima dos vales e selvas deslumbrantes de Bali."
      },
      "Mount Agung Trekking": {
        "title": "Trekking no Monte Agung",
        "description": "Desafie-se com uma gratificante caminhada ao nascer do sol até o pico mais alto de Bali, o Monte Agung."
      },
      "Cooking Class": {
        "title": "Aula de Culinária",
        "description": "Aprenda os segredos da autêntica culinária balinesa com nossos chefs locais especializados."
      },
      "Silver Class": {
        "title": "Aula de Prata",
        "description": "Crie suas próprias joias de prata exclusivas guiadas por ourives tradicionais."
      },
      "Coffee Plantation Tour": {
        "title": "Passeio pela Plantação de Café",
        "description": "Descubra o processo de fabricação do café balinês tradicional, incluindo o famoso café Luwak."
      },
      "Yoga & Wellness": {
        "title": "Yoga e Bem-Estar",
        "description": "Rejuvenesça sua mente e corpo com nossas sessões guiadas de yoga e bem-estar."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "Aperitivos",
      "Soup": "Sopas",
      "Pasta": "Massas",
      "Main Course": "Pratos Principais",
      "Indonesian Food": "Comida Indonésia",
      "Dessert": "Sobremesas",
      "Beverages": "Bebidas"
    },
    "hero": {
      "subtitle": "Restaurante Floresta de Folhas",
      "title": "Uma Jornada Culinária Relaxante",
      "desc": "Delicie-se com criações culinárias requintadas que nutrem o corpo, acompanhadas pelo majestoso panorama do Monte Agung...",
      "btnScroll": "Ver Menu"
    },
    "sidebar": {
      "categories": "Categorias",
      "moreCategories": "Mais Categorias"
    },
    "backToHome": "Voltar ao Início"
  },
  "spa": {
    "categories": {
      "Body Massage": "Massagem Corporal",
      "Specialty Treatments": "Tratamentos Especiais",
      "Body Scrub and Mask": "Esfoliação e Máscara Corporal",
      "Facial Treatment": "Tratamento Facial",
      "Manicure and Pedicure": "Manicure e Pedicure",
      "Spa Packages": "Pacotes de Spa"
    },
    "hero": {
      "subtitle": "Bem-vindo ao Spa Patal Kikian",
      "title": "Onde o Corpo Descansa, a Alma Retorna",
      "desc": "Nosso spa cuida do seu corpo cansado, enquanto a natureza exuberante de Sidemen abraça seu coração...",
      "btnScroll": "Ver Menu Spa"
    },
    "sidebar": {
      "treatments": "Tratamentos",
      "moreTreatments": "Mais Tratamentos"
    },
    "backToHome": "Voltar ao Início"
  },
  "contact": {
    "hero": {
      "subtitle": "Entre em contato",
      "title": "Contate-nos",
      "desc": "Estamos aqui para ajudá-lo. Entre em contato conosco para dúvidas, reservas ou pedidos especiais.",
      "scroll": "Contate-nos"
    },
    "info": {
      "title": "Informação",
      "desc": "Tem alguma dúvida ou precisa de ajuda? Nossa equipe está sempre pronta para ajudá-lo a planejar sua estadia perfeita em Sidemen.",
      "address": "Jl. Raya Sidemen, Sinduwati, Sidemen, Kabupaten Karangasem, Bali 80864"
    },
    "form": {
      "title": "Envie-nos uma mensagem",
      "name": "Seu Nome",
      "email": "Seu Email",
      "subject": "Assunto",
      "message": "Mensagem",
      "btnSend": "Enviar Mensagem",
      "btnSending": "Enviando...",
      "success": "Obrigado! Sua mensagem foi enviada com sucesso.",
      "error": "Ops! Algo deu errado. Por favor, tente novamente mais tarde."
    }
  },
  "faq": {
    "q1": {
      "question": "A que horas é o check-in e check-out?",
      "answer": "O horário de check-in é às 14:00 e o check-out é às 12:00 (meio-dia). O check-in antecipado ou o check-out tardio estão sujeitos à disponibilidade e podem incorrer em taxas adicionais."
    },
    "q2": {
      "question": "O café da manhã está incluído na diária do quarto?",
      "answer": "Sim, um café da manhã diário gratuito está incluído em todas as nossas reservas de vilas."
    },
    "q3": {
      "question": "Vocês oferecem traslados para o aeroporto?",
      "answer": "Sim, oferecemos serviços de traslado para o aeroporto por uma taxa adicional. Por favor, entre em contato conosco com antecedência para organizar sua busca."
    },
    "q4": {
      "question": "O Patal Kikian é adequado para famílias?",
      "answer": "Embora recebamos hóspedes de todas as idades, nossa propriedade foi projetada como um retiro tranquilo. Os pais devem supervisionar as crianças em todos os momentos, especialmente perto da área da piscina."
    },
    "q5": {
      "question": "Vocês acomodam restrições alimentares?",
      "answer": "Absolutamente. Nosso restaurante pode atender a várias necessidades dietéticas, incluindo opções vegetarianas, veganas e sem glúten. Por favor, informe-nos de suas necessidades antes da chegada."
    },
    "q6": {
      "question": "O Wi-Fi está disponível na villa?",
      "answer": "Sim, Wi-Fi de alta velocidade gratuito está disponível em toda a propriedade, incluindo todos os quartos e áreas públicas."
    },
    "subtitle": "Informação",
    "title": "Perguntas Frequentes",
    "stillHaveQuestions": "Ainda tem dúvidas?",
    "btnContact": "Contate-nos"
  },
  "terms": {
    "usage": {
      "title": "Uso do Site",
      "p1": "Bem-vindo ao nosso site. Se você continuar a navegar e usar este site, estará concordando em cumprir e estar vinculado aos seguintes termos e condições de uso, que junto com nossa política de privacidade regem o relacionamento do Patal Kikian Villas com você em relação a este site.",
      "p2": "Se você discorda de qualquer parte destes termos, não use nosso site. O termo 'Patal Kikian Villas' ou 'nós' refere-se ao proprietário do site. O termo 'você' refere-se ao usuário ou visualizador do nosso site.",
      "p3": "O conteúdo das páginas deste site é apenas para sua informação geral e uso. Está sujeito a alterações sem aviso prévio. O uso de qualquer informação ou material neste site é inteiramente por sua conta e risco, pelo qual não seremos responsáveis."
    },
    "booking": {
      "title": "Condições de Reserva",
      "p1_bold": "Seu Contrato com Patal Kikian Villas:",
      "p1": "Estas Condições de Reserva formam a base do seu contrato com o Patal Kikian Villas. Ao fazer uma reserva, a primeira pessoa nomeada na reserva concorda em nome de todas as pessoas detalhadas que leu estes termos e tem autoridade para concordar em se vincular a eles.",
      "p2_bold": "Pagando pela sua reserva:",
      "p2": "No momento da sua reserva, você deverá fornecer detalhes válidos de cartão de crédito ou pagar um depósito por transferência bancária de uma noite para confirmar a reserva. Não comparecimentos (no-shows) serão debitados do cartão.",
      "p3_bold": "Precisão:",
      "p3": "Nós nos esforçamos para garantir que todas as informações e preços em nosso site sejam precisos; no entanto, ocasionalmente ocorrem alterações e erros, e nos reservamos o direito de corrigir os preços."
    },
    "cancellation": {
      "title": "Política de Cancelamento",
      "p1_bold": "Tarifas Padrão:",
      "p1": "Cancelamentos feitos dentro de 14 dias da chegada incorrerão em uma taxa de uma noite. Cancelamentos dentro de 7 dias, ou no caso de não comparecimento, incorrerão em uma taxa de 100% do valor total.",
      "p2_bold": "Tarifas Não Reembolsáveis:",
      "p2": "Reservas feitas sob tarifas não reembolsáveis não podem ser canceladas ou modificadas sem incorrer em uma cobrança de 100%."
    },
    "copyright": {
      "title": "Aviso de Direitos Autorais",
      "p1": "Este site e seu conteúdo são direitos autorais do Patal Kikian Villas. Todos os direitos reservados. Qualquer redistribuição ou reprodução de parte ou de todo o conteúdo sob qualquer forma é proibida."
    },
    "subtitle": "Legal",
    "title": "Termos e Condições"
  },
  "privacy": {
    "policy": {
      "title": "Política de Privacidade",
      "p1": "Entendemos que fornecer informações pessoais envolve muita confiança da sua parte; nós levamos essa confiança muito a sério. Esta política estabelece como o Patal Kikian Villas usa e protege qualquer informação que você nos dá.",
      "p2": "O Patal Kikian Villas está comprometido em garantir que sua privacidade seja protegida. Você pode ter certeza de que as informações só serão usadas de acordo com esta declaração de privacidade.",
      "p3": "Podemos alterar esta política de tempos em tempos atualizando esta página. Você deve verificar esta página periodicamente."
    },
    "collect": {
      "title": "O Que Coletamos",
      "p1": "Podemos coletar as seguintes informações:",
      "l1": "Nome e informações de contato, incluindo endereço de e-mail",
      "l2": "Informações demográficas",
      "l3": "Outras informações relevantes para pesquisas de clientes",
      "l4": "O endereço IP do seu computador"
    },
    "usage": {
      "title": "O Que Fazemos com as Informações",
      "p1": "Exigimos essas informações para entender suas necessidades e fornecer um serviço melhor:",
      "l1": "Manutenção de registros internos.",
      "l2": "Podemos usar as informações para melhorar nossos produtos e serviços.",
      "l3": "Podemos enviar e-mails promocionais para o endereço de e-mail que você forneceu.",
      "l4": "Podemos usar as informações para personalizar o site de acordo com seus interesses.",
      "p2": "Você pode optar por não participar enviando um e-mail para info@patalkikianbali.com."
    },
    "security": {
      "title": "Segurança e Informações Financeiras",
      "p1": "Estamos empenhados em garantir que as suas informações estejam seguras. Implementamos procedimentos físicos e eletrônicos adequados.",
      "p2_bold": "Informações Financeiras:",
      "p2": "Atualmente, não armazenamos informações financeiras, como números de cartão de crédito, em nossos servidores. Os pagamentos são processados por gateways seguros."
    },
    "cookies": {
      "title": "Como Usamos Cookies",
      "p1": "Um cookie ajuda a analisar o tráfego da web. Você pode optar por aceitar ou recusar cookies através das configurações do seu navegador."
    },
    "subtitle": "Legal",
    "title": "Política de Privacidade"
  },
  "footer": {
    "explore": "Explorar",
    "information": "Em formação",
    "desc": "Experimente a vida serena em Sidemen. Desfrute de vistas espetaculares do Monte Agung, vilas luxuosas e hospitalidade calorosa perfeita para viajantes em busca de relaxamento em Bali.",
    "translate": "Traduzir",
    "quickLinks": "Links Rápidos",
    "support": "Suporte",
    "contactTitle": "Contato",
    "contact": "Contato",
    "faq": "FAQ",
    "terms": "Termos e Condições",
    "privacy": "Política de Privacidade",
    "whatsappUs": "WhatsApp",
    "allRightsReserved": "Todos os direitos reservados.",
    "newsJournal": "Notícias e Diário"
  },
  "news": {
    "journal": "Jornal",
    "latest": "Últimas Notícias e Histórias",
    "subtitle": "Fique por dentro das últimas notícias, histórias e eventos em torno de Patal Kikian e Sidemen.",
    "readNews": "Ler Notícias",
    "allArticles": "Todos os Artigos",
    "noArticles": "Nenhum artigo encontrado nesta categoria.",
    "page": "Página",
    "of": "de"
  },
  "newsSearch": {
    "searchBreadcrumb": "Pesquisar",
    "searchResults": "Resultados da Pesquisa",
    "searchArticles": "Pesquisar Artigos",
    "resultsFound": "{{count}} resultados encontrados",
    "forQuery": " para \"{{query}}\"",
    "placeholder": "Pesquisar artigos...",
    "searchBtn": "Pesquisar",
    "noResults": "Nenhum artigo encontrado para \"{{query}}\".",
    "enterKeyword": "Insira uma palavra-chave para pesquisar.",
    "backToNews": "Voltar para Notícias"
  },
  "newsCategory": {
    "category": "Categoria",
    "articlesInCat": "artigos nesta categoria",
    "noArticles": "Nenhum artigo encontrado nesta categoria.",
    "backToNews": "Voltar para Notícias"
  },
  "newsDetail": {
    "tags": "Tags",
    "exclusiveStay": "Estadia Exclusiva",
    "promoDesc": "Experimente o Luxo Premium em Sidemen",
    "bookStay": "Reserve Sua Estadia",
    "reserveStay": "Reserve Sua Estadia",
    "villaRecs": "Recomendações de Villas",
    "recAccommodations": "Acomodações Recomendadas",
    "readArticle": "Ler Artigo",
    "search": "Pesquisar",
    "searchPlaceholder": "Pesquisar artigos...",
    "go": "Ir",
    "categories": "Categorias",
    "popularPosts": "Artigos Populares",
    "bookNow": "Reservar Agora",
    "notFound": "Artigo Não Encontrado",
    "notFoundDesc": "O artigo que você procura não existe ou foi movido.",
    "backToNews": "Voltar para Notícias"
  }
}